import React, { Fragment, useEffect, useState } from 'react';
import { COLORS, defaultTimeProps } from '@constants';
import { useStore } from '@hooks';
import { readDateRangeFromStorage } from '@pages/Performance/utils';
import { Divider } from '@ui';
import { observer } from 'mobx-react';
import { CreateCampaignModal } from '../../components/CreateCampaignModal';
import { SetupPayoutsModal } from '../../components/SetupPayoutsModal';
import { PERFORMANCE_BLOCKS } from './PerformanceSection/constants';
import CampaignsSection from './CampaignsSection';
import HeadSection from './HeadSection';
import PerformanceSection from './PerformanceSection';
import RecommendationsSection from './RecommendationsSection';
import SupportSection from './SupportSection';
import ThemeExtensionNotification from './ThemeExtensionNotification';

const Home = observer(() => {
    const store = useStore();
    const { getMetricsOverview, getLiveCampaigns, pendingLiveCampaigns, liveCampaigns, getBreakdowns, getTopSites } =
        store.performanceStore;
    const { getCampaigns } = store.campaignsStore;
    const { isActive, showSetupPayoutsModal, showCreateCampaignModal, isBlocked } = store.accountsStore;
    const [isSetupPayoutsModal, setIsSetupPayoutsModal] = useState(showSetupPayoutsModal);
    const [isCreateCampaignModal, setIsCreateCampaignModal] = useState(showCreateCampaignModal);
    const [performanceDateRange] = useState(readDateRangeFromStorage);

    useEffect(() => {
        (async () => {
            const performanceTimeProps = performanceDateRange ?? defaultTimeProps;

            await Promise.all([
                getMetricsOverview({
                    ...performanceTimeProps,
                    metrics: PERFORMANCE_BLOCKS.map((item) => item.label)
                }),
                getLiveCampaigns(defaultTimeProps),
                getBreakdowns(performanceTimeProps),
                getTopSites(performanceTimeProps),
                getCampaigns()
            ]);
        })();

        if (window.klpixel) {
            window.klpixel('event', 'blocked', {});
        }
    }, []);

    return (
        <Fragment>
            {!isBlocked && <SupportSection />}
            <ThemeExtensionNotification />
            <HeadSection />
            <Divider style={{ borderBlockStart: `1px solid ${COLORS.$gray20Black}` }} margin='48px 0' />
            {!pendingLiveCampaigns && !liveCampaigns?.length && !isActive ? null : <CampaignsSection />}
            <PerformanceSection dateRange={performanceDateRange} />
            {!isBlocked ? (
                <Fragment>
                    <Divider style={{ borderBlockStart: `1px solid ${COLORS.$gray20Black}` }} margin='48px 0' />
                    <RecommendationsSection />
                    <SetupPayoutsModal isModalOpen={isSetupPayoutsModal} setIsModalOpen={setIsSetupPayoutsModal} />
                    <CreateCampaignModal
                        isModalOpen={isCreateCampaignModal}
                        setIsModalOpen={setIsCreateCampaignModal}
                    />
                </Fragment>
            ) : null}
        </Fragment>
    );
});

export default Home;
